export default "__VITE_ASSET__CABmgzXY__"